export const IgnoreScopes = ['mobile:', 'dev:'];
